import { getGlobalProps } from '../utils/queryHelpers';
import { DEFAULT_CHECK_DIGIT_TYPE } from '../constants/constants';

const EProNumber = () => {
  const {
    orgInfo: { orgId }
  } = getGlobalProps();

  return {
    id: null,
    carrierId: null,
    sequenceStart: null,
    sequenceEnd: null,
    checkDigitTypeId: DEFAULT_CHECK_DIGIT_TYPE,
    format: null,
    locations: [],
    forInbound: false,
    forOutbound: false,
    suspended: false,
    orgId
  };
};

export const sanitize = values => {
  const {
    sequenceStart,
    sequenceEnd,
    checkDigitTypeId,
    format,
    locations,
    orgId,
    forInbound,
    forOutbound,
    suspended
  } = values;
  const locationInfos = locations.map(location => ({
    locationId: location.value,
    forInbound,
    forOutbound
  }));
  return {
    name: format,
    sequenceStart,
    sequenceEnd,
    checkDigitTypeId,
    format,
    orgId,
    locationInfos,
    suspended
  };
};

export default EProNumber;
